<template>
  <a-row class="controls" type="flex" justify="space-between">
    <a-col>
      <a-form layout="inline" ref="formRef" :model="formState">
        <a-form-item>
          <a-input v-model:value="formState.name" placeholder="Buscar" class="form__input">
            <template #prefix>
              <search-outlined />
            </template>
          </a-input>
        </a-form-item>

        <ChannelsPicker
          :value="formState.channel"
          @update:value="formState.channel = $event"
          class="form__item"
          isChatbot
        />

        <a-form-item>
          <a-select
            :getPopupContainer="(triggerNode) => triggerNode.parentNode"
            v-model:value="formState.status"
            class="form__item"
            placeholder="Seleccionar estado"
          >
            <a-select-option :key="0"> Todos los estados </a-select-option>
            <a-select-option :key="ChatbotStatus.Active"> Activos </a-select-option>
            <a-select-option :key="ChatbotStatus.Inactive"> Inactivos </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-col>
  </a-row>
</template>

<script>
import { ref, watch, defineComponent, inject } from "vue";

import { SearchOutlined } from "@ant-design/icons-vue";
import _ from "lodash";

import { ChatbotStatus } from "@/app/chatbots/utils/enums";

import ChannelsPicker from "@/app/shared/components/pickers/ChannelsPicker.vue";

export default defineComponent({
  components: {
    SearchOutlined,
    ChannelsPicker,
  },
  setup(props, { emit }) {
    const formRef = ref(null);
    const formState = inject("filtersState");

    const handleSearch = () => {
      emit("search");
    };

    watch(
      formState,
      _.debounce(() => {
        handleSearch();
      }, 600),
      { deep: false }
    );

    return {
      formRef,
      formState,
      ChatbotStatus,
    };
  },
});
</script>

<style lang="sass" scoped>
.form__input
  width: 280px

.form
  &__item
    min-width: 180px

    &--large
      min-width: 260px
</style>
